import { getAccessibleTextColor } from "../utilities";

let defaultLight = {
  primary: "#bb0000",
  secondary: "#666666",
  background: "#fafafa",
  action: "#bb0000",
  responseMessage: {},
  userMessage: {}
};
defaultLight.responseMessage.background = defaultLight.background
defaultLight.responseMessage.border = defaultLight.secondary
defaultLight.userMessage.background = '#333333'
defaultLight.userMessage.border = ''

const defaultDark = {
  ...defaultLight,
  background: "#414141",
  secondary: "#D4D4D4",
  action: "#81b4f5",
  responseMessage: {},
  userMessage: {}
};
defaultDark.responseMessage.background = defaultDark.background
defaultDark.responseMessage.border = defaultDark.secondary
defaultDark.userMessage.background = '#ffffff'
defaultDark.userMessage.text = '#333333'
defaultDark.userMessage.border = ''

const getPalette = (overrides = {}) => {
  const { type = "light", ...rest } = overrides;
  let palette = {
    type,
    ...(type === "dark" ? defaultDark : defaultLight),
  };
  let combinedPalette = {
    ...palette,
    ...rest
  }

  if(!combinedPalette.text) {
    combinedPalette.text = combinedPalette.background ? getAccessibleTextColor(combinedPalette.background) : ''
  }
  if(!combinedPalette.responseMessage.text) {
    combinedPalette.responseMessage.text = combinedPalette.responseMessage.background ? getAccessibleTextColor(combinedPalette.responseMessage.background) : ''
  }
  if(!combinedPalette.userMessage.text) {
    combinedPalette.userMessage.text = combinedPalette.userMessage.background ? getAccessibleTextColor(combinedPalette.userMessage.background) : ''
  }

  return combinedPalette
};

export { getPalette };
